<template>
  <iColumn align="center">
    <iText>Please sign into your Account</iText>
    <iTextInput
      v-model="userAuthEmail"
      disabled
      width="fill"
      right-icon="pencil"
      focus
      @click-icon-right="goBackToEmailStep"
    />
    <iTextInput
      v-model="password"
      type="password"
      width="fill"
      focus
      @enter="login"
    />
    <iText v-if="loginErrorMessage" variant="error">
      {{ loginErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading"
      @click="login"
    >
      Continue
    </iButton>
    <iLink @click="forgotPassword">
      Forgot password?
    </iLink>
    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "@/components/join-publication/PoweredByInspiration";
import { mapState, mapWritableState } from "pinia";
import { useUserStore } from "~/stores/user-store";
import { FORGOT_PASSWORD_FORM } from "@/constants/login-flow-constants";

export default {
  name: "JoinPublicationPassword",
  components: { PoweredByInspiration },
  data() {
    return {
      password: "",
    };
  },
  computed: {
    ...mapWritableState(useUserStore, ["userAuthEmail", "userFlowSteps", "loginErrorMessage"]),
    ...mapState(useUserStore, ["isLoading"]),
  },
  mounted() {
    this.loginErrorMessage = "";
  },
  methods: {
    login() {
      useUserStore().loginUser(this.password, 1);
    },
    goBackToEmailStep() {
      this.userFlowSteps.pop();
    },
    forgotPassword() {
      this.userFlowSteps.push(FORGOT_PASSWORD_FORM);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
